module.exports = __webpack_public_path__ + "assets/a01fb893bfba9ed20c4074754587de7c.mp3";